import { useTranslation } from "react-i18next";
import { observationsType } from "@/schemas/observation-schema";

import WindDirection from "@/components/wind-direction/WindDirection";
import Skeleton from "@/components/skeletons/Skeleton";

import "./style.scss";

type WeatherInfoProps = {
	weatherData: observationsType[number]["data"];
	isLoading: boolean;
	error: string | null;
};

export const WeatherInfo = ({
	weatherData,
	isLoading,
	error,
}: WeatherInfoProps) => {
	const { t } = useTranslation();

	if (isLoading) {
		return (
			<div className="weather-info">
				<Skeleton className="weather-stat-card" length={5} />
			</div>
		);
	}

	if (error) {
		return (
			<div className="weather-info">
				<p>{t("fetchError")}</p>
			</div>
		);
	}

	return (
		<div className="weather-info">
			<div className="weather-stat-card">
				<span className="label">{t("wind")}</span>
				<span className="value">
					{weatherData?.wind_speed ?? "-"} <small>{t("km/h")}</small>
				</span>
			</div>

			<div className="weather-stat-card">
				<span className="label">{t("windDirection")}</span>
				{weatherData?.wind_direction !== undefined ? (
					<WindDirection
						color="var(--wp--preset--color--base)"
						rotation={weatherData?.wind_direction ?? 0}
					/>
				) : (
					"-"
				)}
			</div>

			<div className="weather-stat-card">
				<span className="label">{t("visibility")}</span>
				<span className="value">{weatherData?.visibility ?? "-"} </span>
			</div>

			<div className="weather-stat-card">
				<span className="label">{t("humidity")}</span>
				<span className="value">
					{weatherData?.relative_humidity ?? "-"} <small>%</small>
				</span>
			</div>

			<div className="weather-stat-card">
				<span className="label">{t("raindLast24Hours")}</span>
				<span className="value">{weatherData?.precipitation_3h ?? "-"}</span>
			</div>
		</div>
	);
};

export default WeatherInfo;
